import { __extends } from "tslib";
import { BitmapImage2D } from '@awayjs/stage';
import { Timeline, MovieClip, Sprite, Billboard, MorphSprite, FrameScriptManager, } from '@awayjs/scene';
import { MethodMaterial } from '@awayjs/materials';
import { DefaultSceneGraphFactory } from '@awayjs/scene';
import { Bitmap } from '../display/Bitmap';
import { BitmapData } from '../display/BitmapData';
import { Graphics } from '@awayjs/graphics';
import { Multiname, constructClassFromSymbol, ABCFile, } from '@awayfl/avm2';
import { BasicPartition } from '@awayjs/view';
var FlashSceneGraphFactory = /** @class */ (function (_super) {
    __extends(FlashSceneGraphFactory, _super);
    function FlashSceneGraphFactory(sec, loaderInfo) {
        var _this = _super.call(this) || this;
        _this.imageStore = {};
        _this._sec = sec;
        _this._loaderInfo = loaderInfo;
        return _this;
    }
    Object.defineProperty(FlashSceneGraphFactory.prototype, "appDomain", {
        get: function () {
            if (this._loaderInfo) {
                return this._loaderInfo.applicationDomain.axApplicationDomain;
            }
            return this._sec.application;
        },
        enumerable: false,
        configurable: true
    });
    FlashSceneGraphFactory.prototype.executeABCBytes = function (abcBlocks) {
        for (var i = 0; i < abcBlocks.length; i++) {
            var abcBlock = abcBlocks[i];
            var abc = new ABCFile({ app: this.appDomain, url: '' }, abcBlock.data);
            if (abcBlock.flags) {
                // kDoAbcLazyInitializeFlag = 1 Indicates that the ABC block should not be executed
                // immediately.
                this.appDomain.loadABC(abc);
            }
            else {
                // TODO: probably delay execution until playhead reaches the frame.
                this.appDomain.loadAndExecuteABC(abc);
            }
        }
        return null;
    };
    FlashSceneGraphFactory.prototype.createSprite = function (_prefab, graphics, symbol) {
        if (_prefab === void 0) { _prefab = null; }
        if (graphics === void 0) { graphics = null; }
        if (symbol === void 0) { symbol = null; }
        if (!symbol || !this._sec)
            throw ('no symbol provided');
        var symbolClass = null;
        if (symbol.className)
            symbolClass = this.appDomain.getClass(Multiname.FromFQNString(symbol.className, 0 /* NamespaceType.Public */));
        else
            symbolClass = this._sec.flash.display.Sprite.axClass;
        symbol.symbolClass = symbolClass;
        //Graphicsadapter.currentAwayGraphics=graphics;
        // create the root for the root-symbol
        var asObj = constructClassFromSymbol(symbol, symbolClass);
        asObj.adaptee = new Sprite(graphics);
        asObj.adaptee.name = graphics.name;
        // manually call the axInitializer for now:
        //asObj.axInitializer(Sprite.getNewSprite(new this._sec.flash.display.Graphics(graphics).adaptee));
        return asObj.adaptee;
    };
    FlashSceneGraphFactory.prototype.createDisplayObjectContainer = function (_symbol) {
        if (_symbol === void 0) { _symbol = null; }
        return new this._sec.flash.display.DisplayObjectContainer().adaptee;
    };
    FlashSceneGraphFactory.prototype.createBinarySymbol = function (symbol) {
        if (symbol === void 0) { symbol = null; }
        this.appDomain.addBinarySymbol(symbol);
    };
    FlashSceneGraphFactory.prototype.createMovieClip = function (timeline, symbol) {
        if (timeline === void 0) { timeline = null; }
        if (symbol === void 0) { symbol = null; }
        if (!symbol || !this._sec)
            throw ('no symbol provided');
        var symbolClass = null;
        if (symbol.className) {
            symbolClass = this.appDomain.getClass(Multiname.FromFQNString(symbol.className, 0 /* NamespaceType.Public */));
            symbolClass._symbol = symbol;
        }
        else if (symbol.isButton) {
            symbolClass = this._sec.flash.display.SimpleButton.axClass;
        }
        else {
            symbolClass = this._sec.flash.display.MovieClip.axClass;
        }
        //console.log("parsed symbolClass", symbolClass, symbol);
        symbol.symbolClass = symbolClass;
        // create the root for the root-symbol
        var rootSymbolClass = symbol.isButton
            ? this._sec.flash.display.SimpleButton.axClass
            : this._sec.flash.display.MovieClip.axClass;
        var asObj = constructClassFromSymbol(symbol, rootSymbolClass);
        asObj.adaptee = new MovieClip(timeline || new Timeline(this));
        symbol.timeline = asObj.adaptee.timeline;
        //(<MovieClip>asObj.adaptee).timeline.resetScripts();
        //(<any>asObj).axInitializer();
        return asObj.adaptee;
    };
    FlashSceneGraphFactory.prototype.createTextField = function (symbol) {
        if (symbol === void 0) { symbol = null; }
        var symbolClass = null;
        if (symbol.className) {
            symbolClass = this.appDomain.getClass(Multiname.FromFQNString(symbol.className, 0 /* NamespaceType.Public */));
        }
        else {
            symbolClass = this._sec.flash.text.TextField.axClass;
        }
        symbol.symbolClass = symbolClass;
        // create the root for the root-symbol
        var asObj = constructClassFromSymbol(symbol, symbolClass);
        // 	manually call the axInitializer - this will run the constructor
        //	creating new Away-MovieClip and timeline, and registers framescripts on the timeline:
        asObj.axInitializer();
        return asObj.adaptee;
    };
    FlashSceneGraphFactory.prototype.createBillboard = function (material, _symbol) {
        if (_symbol === void 0) { _symbol = null; }
        return new Bitmap(material.style.image.adapter).adaptee;
    };
    FlashSceneGraphFactory.prototype.createImage2D = function (width, height, transparent, fillColor, _powerOfTwo, _symbol) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = null; }
        if (_powerOfTwo === void 0) { _powerOfTwo = true; }
        if (_symbol === void 0) { _symbol = null; }
        var image = new BitmapData(width, height, transparent, fillColor).adaptee;
        // drop weak ref for symbols
        image.unuseWeakRef();
        return image;
    };
    FlashSceneGraphFactory.prototype.createFrameScripts = function (_scripts, _frameIdx, _objName, _objID) {
        return _scripts;
    };
    /**
     * Get a instance for a given SymbolID and assign a sessionID to it.
     * This is used by timeline to create children
     *
     * @param symbolID
     * @param sessionID
     */
    FlashSceneGraphFactory.prototype.createChildInstanceForTimeline = function (timeline, symbolID, sessionID) {
        // if this was called we might have new constructors from timeline to process
        FrameScriptManager.invalidAS3Constructors = true;
        var asset = this.awaySymbols[symbolID];
        var clone;
        if (asset.isAsset(Graphics)) {
            clone = Sprite.getNewSprite(asset.clone()); //TODO: remove this clone() without the mem leak
            clone.name = asset.name;
            clone.mouseEnabled = false;
        }
        else if (asset.isAsset(Sprite)) {
            clone = Sprite.getNewSprite(asset.graphics);
            clone.mouseEnabled = false;
        }
        else if (asset.isAsset(MorphSprite)) {
            clone = MorphSprite.getNewMorphSprite(asset.graphics.clone());
            clone.mouseEnabled = false;
        }
        else if (asset.isAsset(BitmapImage2D)) {
            // enable blending for symbols, because if you place image directly on stage
            // it not enable blend mode
            var m = new MethodMaterial(asset);
            m.alphaBlending = asset.transparent;
            clone = Billboard.getNewBillboard(m);
            clone.mouseEnabled = false;
        }
        else {
            clone = asset.adapter.clone(false).adaptee;
        }
        clone.partitionClass = BasicPartition;
        clone._sessionID = sessionID;
        return clone;
    };
    return FlashSceneGraphFactory;
}(DefaultSceneGraphFactory));
export { FlashSceneGraphFactory };
